var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoContainer"},[_c('img',{staticClass:"logoHeader",attrs:{"alt":_vm.name,"src":_vm.companyLogo}})])}
var staticRenderFns = []

export { render, staticRenderFns }